import React from 'react';
import MoodTracker from '../components/MoodTracker';

const MoodTrackerPage = () => {
  return (
    <div className="mood-tracker-page">
      <MoodTracker />
    </div>
  );
};

export default MoodTrackerPage;
